import React, {Component} from "react";
import {Drawer, message, Select} from "antd";
import {CloseOutlined} from '@ant-design/icons';
import {map, isEmpty} from "lodash";
import * as yup from "yup";
import moment from 'moment-timezone';
import Loader from "../../../../Common/Component/Loader";

const {Option} = Select;

const roles = [{key: 'Board Member', value: 'board_member'}, {key: 'Concerned Resident', value: 'concerned_resident'}]

class UpdateGuest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customer: {},
      uuid: '',
      name: '',
      role: '',
      email: '',
      phone: '',
      permissions: [{
        name: 'proposal_ready',
        type_display: 'Proposal ready',
        email: false,
        text: false
      }, {
        name: 'proposal_signed',
        type_display: 'Proposal signed',
        email: false,
        text: false
      }, {
        name: 'installation_scheduled',
        type_display: 'Installation scheduled',
        email: false,
        text: false
      }, {
        name: 'installation_complete',
        type_display: 'Installation complete',
        email: false,
        text: false
      }, {
        name: 'service_complete',
        type_display: 'Service complete',
        email: false,
        text: false
      }, {
        name: 'service_issues',
        type_display: 'Service issue',
        email: false,
        text: false
      }, {
        name: 'billing_notifications',
        type_display: 'Billing notification',
        email: false,
        text: false
      }],
      is_btn_active: false,
      is_edit: false,
      deleteUsers: [],
      loader: false,
      selected_index: '',
      errors: {}
    }
  }

  componentDidMount() {
    const {customerId, getCommercialCustomer} = this.props;
    if (customerId) {
      getCommercialCustomer(customerId) // get customer detail
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy();
    const {customer} = this.state;
    this.setState({loader: false});

    // get customer info
    if (nextProps.CommercialCustomer && nextProps.CommercialCustomer.getCustomer && Object.keys(nextProps.CommercialCustomer.getCustomer).length > 0
    && JSON.stringify(nextProps.CommercialCustomer.getCustomer) !== JSON.stringify(customer)) {
      let customer = nextProps?.CommercialCustomer?.getCustomer
      const phone_number = customer?.phone_numbers?.find((obj) => obj.primary === true)
      if (isEmpty(customer?.guest_users)) {
        customer.guest_users = [{user_name: customer?.community_name, phone_number: phone_number?.phone, email: customer?.email, user_uuid: customer?.uuid,
          role: 'community_manager',
          permissions: [{
            name: 'proposal_ready',
            type_display: 'Proposal ready',
            email: false,
            text: false
          }, {
            name: 'proposal_signed',
            type_display: 'Proposal signed',
            email: false,
            text: false
          }, {
            name: 'installation_scheduled',
            type_display: 'Installation scheduled',
            email: false,
            text: false
          }, {
            name: 'installation_complete',
            type_display: 'Installation complete',
            email: false,
            text: false
          }, {
            name: 'service_complete',
            type_display: 'Service complete',
            email: false,
            text: false
          }, {
            name: 'service_issues',
            type_display: 'Service issue',
            email: false,
            text: false
          }, {
            name: 'billing_notifications',
            type_display: 'Billing notification',
            email: false,
            text: false
          }]}]
      }
      this.setState({customer: nextProps?.CommercialCustomer?.getCustomer});
    }
  }

  // format phone number
  formatPhoneNumber = (phone) => {
    if (!phone) return ''
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  //on cancel
  onCancel = () => {
    this.onClear();
    this.props.closeDrawer();
    setTimeout(() => {
      this.props.getCommercialCustomer(this.props.customerId) // get customer detail
    }, 500)
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // toggle edit detail
  toggleEdit = (item, index) => {
    const {permissions} = this.state;
    const per = permissions?.map(x => ({...x, email: (item?.permissions?.find(a => a.name === x.name))?.email || false, text: (item?.permissions?.find(a => a.name === x.name))?.text || false}))
    this.setState({
      selected_index: index,
      uuid: item?.uuid,
      name: item?.user_name,
      role: item?.role,
      email: item?.email,
      phone: item?.phone ? item?.phone : item?.phone_number,
      permissions: per,
      is_edit: true
    })
  }

  // on guest user info change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value })
  }

  // on permission change
  onPermissionChanged = (e, type) => {
    const { permissions } = this.state;
    const idx = permissions.findIndex(obj => obj.name === type);
    if (idx > -1) {
      permissions[idx] = Object.assign(permissions[idx], { [e.target.name]: e.target.checked });
      this.setState({ permissions });
    }
  }

  // clear all data
  onClear = () => {
    this.setState({
      uuid: '',
      name: '',
      role: '',
      email: '',
      phone: '',
      permissions: [{
        name: 'proposal_ready',
        type_display: 'Proposal ready',
        email: false,
        text: false
      }, {
        name: 'proposal_signed',
        type_display: 'Proposal signed',
        email: false,
        text: false
      }, {
        name: 'installation_scheduled',
        type_display: 'Installation scheduled',
        email: false,
        text: false
      }, {
        name: 'installation_complete',
        type_display: 'Installation complete',
        email: false,
        text: false
      }, {
        name: 'service_complete',
        type_display: 'Service complete',
        email: false,
        text: false
      }, {
        name: 'service_issues',
        type_display: 'Service issue',
        email: false,
        text: false
      }, {
        name: 'billing_notifications',
        type_display: 'Billing notification',
        email: false,
        text: false
      }],
      is_edit: false,
      errors: {}
    })
  }

  // validate required fields
  validate = (action) => {
    const {name, phone, email, role} = this.state;

    const schema = yup.object().shape({
      name: yup.string().required('name is required'),
      // phone:  yup.string().required('phone is required'),
      email: yup.string().nullable(true).email('Invalid email'),
      // role: yup.string().required('role is required'),
    });

    const data = {name, phone, email, role}

    setTimeout(() => {
      schema.validate(data, {abortEarly: false}).then(() => {
        this.setState({is_btn_active: true, errors: {}});
        if (action === 'edit') this.onUpdateGuest()
        else this.onAddGuest()
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {err_data[item.path] = item.message})
        this.setState({errors: err_data, is_btn_active: false})
      })
    }, 500);
  }

  // on add guest
  onAddGuest = () => {
    const {name, role, email, phone, permissions, customer, errors} = this.state;
    let is_email_exist = false;
    map(customer?.guest_users, (x) => {if (x.email && x.email === email) is_email_exist = true})
    if (is_email_exist) {
      this.setState({errors: {...errors, 'email': 'Email already exist'}})
    } else {
      customer.guest_users.push({user_name: name,
        email,
        role,
        phone_number: phone,
        user_uuid: customer?.uuid,
        permissions: permissions
      })
      this.setState({customer}, () => this.onClear())
    }
  }

  // on update guest
  onUpdateGuest = () => {
    const {name, role, email, phone, permissions, customer, uuid, selected_index, errors} = this.state;
    const idx = uuid ? customer?.guest_users?.findIndex(x => x.uuid === uuid) : selected_index;
    let is_email_exist = false;
    map(customer?.guest_users, (x, index) => {
      if (x.email && idx !== index && x.email === email) is_email_exist = true})
    if (is_email_exist) {
      this.setState({errors: {...errors, 'email': 'Email already exist'}})
    } else if (idx > -1) {
      customer.guest_users[idx] = {uuid, user_name: name, email, role, phone_number: phone, user_uuid: customer?.uuid, permissions: permissions}
      this.setState({customer}, () => this.onClear())
    }
  };

  onDeleteGuest = (uuid, index) => {
    const {customer, deleteUsers} = this.state;
    let idx = index;
    if (uuid) {deleteUsers.push(uuid); idx = customer?.guest_users?.findIndex(x => x.uuid === uuid)}
    if (idx > -1) {customer.guest_users.splice(idx, 1); this.setState({customer, deleteUsers})}
  };

  // on update
  onUpdate = () => {
    const {customer, deleteUsers} = this.state;
    const {addGuestUser, updateGuestUser, deleteGuestUser} = this.props;
    let arr = [];
    this.setState({loader: true});
    map(customer?.guest_users, (obj) => {
      if (obj.uuid) arr.push(updateGuestUser(obj)) // update guest user
      else arr.push(addGuestUser(obj)) // add guest user
    })
    
    map(deleteUsers, (uuid) => arr.push(deleteGuestUser(uuid))) // delete guest user
    
    Promise.all(arr).then((response) => {
      if (!isEmpty(response)) {
        setTimeout(() => {
          this.onCancel();
        }, 1500)
      }
    })
  }
  
  renderAddGuest = () => {
    const {name, phone, email, role, permissions, errors, is_edit} = this.state;
    const temp_role = (is_edit && role === 'community_manager') ? [...roles, {key: 'Community Manager', value: 'community_manager'}] : [...roles];
    return (
      <div className="card-full">
        <h4>Guest Users</h4>
        <div className={'flex'}>
          <div>
            <label>{is_edit ? 'Edit Guest User' : 'New Guest User'}</label>
          </div>
          <div>
            <a className="success float-right"  href={'/#'} onClick={(e) => {e.preventDefault(); this.onClear()}}><u>Clear</u></a>
          </div>
        </div>
       
        <div className="form-group">
          <div className="fitem">
            <input
              type="text"
              name={"name"}
              value={name}
              onChange={(e) => this.onTextChange(e)}
              className="form--control"
              placeholder="Enter name"
            />
            {errors?.['name'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['name']}</label> : ''}
          </div>
          <div className="fitem">
            <Select
              showArrow={true}
              name="role"
              placeholder="Select Role"
              onChange={(value) => this.onTextChange({ target: { name: 'role', value: value } })}
              value={role || undefined}
              virtual={false}
            >
              {map(temp_role, (obj) => <Option value={obj.value} key={obj.value}>{obj.key}</Option>)}
            </Select>
          </div>
          <div className="fitem">
            <input
              type="text"
              name={"email"}
              value={email}
              onChange={(e) => this.onTextChange(e)}
              className="form--control"
              placeholder="Enter email address"
            />
            {errors?.['email'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['email']}</label> : ''}
          </div>

          <div className="fitem">
            <input
              type="text"
              name={"phone"}
              value={phone}
              onChange={(e) => this.onTextChange(e)}
              className="form--control"
              placeholder="Enter phone number"
              maxLength={"10"}
              max={"10"}
            />
          </div>
        </div>
        <div className="card-body">
          {
           permissions?.length > 0 &&
             <div className={"flex"}>
               <label htmlFor="checkbox">Permissions</label>
               <div className="fitem-check text-right">
                 <label htmlFor="checkbox" className="fitem-ck-txt text-right"><b>Email</b></label>
                 <label htmlFor="checkbox" className="fitem-ck-txt text-right"><b>Text</b></label>
               </div>
             </div>
          }
          {
            map(permissions, (item, index) => {
              return (
                <div className={"flex ai-center mb-10"} key={`notification${index}`}>
                  <label><b>{item?.type_display}</b></label>
                  <div className="inline-check-list rcheck flex sm-checks gcheck">
                    <div className="fitem-check">
                      <input
                        type="checkbox"
                        className="fitem-ck-input"
                        id={`permissionGuestCommunityEmail${index}`}
                        name={`email`}
                        checked={item?.email}
                        onChange={(e) => this.onPermissionChanged(e, item?.name)}
                      />
                      <label htmlFor={`permissionGuestCommunityEmail${index}`} className="fitem-ck-txt"/>
                    </div>
                    <div className="fitem-check">
                      <input
                        type="checkbox"
                        className="fitem-ck-input"
                        id={`permissionGuestCommunityText${index}`}
                        name={`text`}
                        checked={item?.text}
                        onChange={(e) => this.onPermissionChanged(e, item?.name)}
                      />
                      <label htmlFor={`permissionGuestCommunityText${index}`} className="fitem-ck-txt"/>
                    </div>
                  </div>
                </div>
              )
            })
          }
          <div className={'flex'}>
            {is_edit ? <button
              // type="submit"
              // disabled={!is_btn_active}
              className={`btn btn-full btn-bdr`}
              onClick={() => this.validate('edit')}>
              Update Guest User
            </button> :
              <button
                // type="submit"
                // disabled={!is_btn_active}
                className={`btn btn-full btn-bdr`}
                onClick={() => this.validate('save')}>
              Add Guest User
              </button>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {openDrawer} = this.props;
    const {customer, loader} = this.state;
    const accountHolder = customer?.guest_users?.find(x => x.role === 'community_manager')
    const account_idx = customer?.guest_users?.findIndex(x => x.role === 'community_manager') || 0

    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={() => this.onCancel()}
        visible={openDrawer}
        key={'right'}
        width={'400'}
        className="drawer-wrapper"
      >
        <div className="rdrawer filter_drawer_wrapper prime-info">
          {loader && <Loader />}
          <div className={"card-row flex-column"}>
            <div className="card-full pb-0">
              <div className="flex ai-center">
                <h4 className="mb-0">Primary Information</h4>
                <CloseOutlined onClick={() => this.onCancel()}/>
              </div>              
            </div>
            <div>
              <div className='ml-30 mr-30 mt-10'>
                <div className="flex flex-start mb-10">
                  <div className="label">
                    <b>{accountHolder?.user_name}</b>
                  </div>
                  <div className="value">&nbsp;&nbsp;<b>{`(Account Holder)`}</b></div>
                  <div className={'flex-1'}>
                    <a className="success float-right"  href={'/#'} onClick={(e) => {e.preventDefault(); this.toggleEdit(accountHolder, account_idx)}}><u>Edit</u></a>
                  </div>
                </div>
              </div>
              {
                map(customer?.guest_users, (obj, index) => {
                  if (obj.role !== 'community_manager' && obj.role !== 'billing' && obj.role !== 'management') {
                    const role = roles.filter(x => x.value === obj.role)
                    return (
                      <div key={`guest${index}`} className='ml-30 mr-30 mt-10'>
                        <div className="flex flex-start mb-10">
                          <div className="label">
                            <b>{obj?.user_name ? obj?.user_name : ''}</b>
                          </div>
                          <div className="value">&nbsp;&nbsp;{role.length > 0 ? `${role?.[0]?.key}` : ''}</div>
                          <div className={'flex-1'}>
                            <a className="red float-right"  href={'/#'} onClick={(e) => {e.preventDefault(); this.onDeleteGuest(obj.uuid, index)}}><u>Remove</u></a>
                          </div>
                        </div>
                        <div>{obj?.email ? `${obj?.email}` : ''}</div>
                        <div>{`Added ${obj?.created_at ? moment(obj?.created_at).format('MM/DD/YYYY') : moment().format('MM/DD/YYYY')}`}</div>
                        <div className={'flex'}>
                          <div className={'flex-1'}>
                            <a className="success"  href={'/#'} onClick={(e) => {e.preventDefault(); this.toggleEdit(obj, index)}}><u>Edit Permissions</u></a>
                          </div>
                          {/*<div className={'flex-1'}>
                            <a className="success float-right"  href={'/#'} onClick={(e) => {e.preventDefault(); this.toggleEdit(obj, index)}}><u>Edit</u></a>
                          </div>*/}
                        </div>
                      </div>
                    )
                  }
                })
              }
              {this.renderAddGuest()}
            </div>
          </div>
          <div className="footer" style={{ 'width': '420px' }}>
            <button
              onClick={() => this.onCancel()}
              className="btn btn-brand btn-bdr"
            >Cancel</button>
            <button
              className={'btn btn-warning'}
              onClick={() => this.onUpdate()}
            >Update</button>
          </div>
        </div>
      </Drawer>
    )
  }
}

export default UpdateGuest;